const AnalyticsCategories = {
    Invitation: 'Invitations',
    Chat: 'ChatWidgets'
};
export default AnalyticsCategories;
